import React, { useEffect } from 'react';
import { setSubpage } from '../../../routes/routerSlice';
import { ConfigurationSubpage } from '../Configuration';
import RegionFlowTypeSection from './RegionFlowTypeSection/RegionFlowTypeSection';
import RegionGroupConfigurations from './RegionGroupConfigurations/RegionGroupConfigurations';
import { useGetCalculationConfigurationQuery } from '../../../apis/apiGlobalConfiguration';
import { RegionFlowType } from '@ydistri/api-sdk';
import { MainContent } from '@ydistri/ds';
import { useAppDispatch } from '../../../store';
import { useTemplateOrCalculationWithValue } from '../../../hooks/useTemplateOrCalculationWithValue';

const ConfigurationRegions: React.FC = () => {
  const dispatch = useAppDispatch();
  const templateOrCalculation = useTemplateOrCalculationWithValue();

  const { data: calculationConfiguration } = useGetCalculationConfigurationQuery(
    templateOrCalculation.value,
  );

  useEffect(() => {
    dispatch(setSubpage(ConfigurationSubpage.REGIONS));
  });

  return (
    <MainContent>
      <RegionFlowTypeSection />
      {calculationConfiguration?.regionFlowTypeId === RegionFlowType.CustomRedistribution && (
        <RegionGroupConfigurations />
      )}
    </MainContent>
  );
};

export default ConfigurationRegions;
